<template>
  <div class="navbar">
    <!-- 侧边栏收缩 -->
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <div class="right-menu">
      <!-- 用户个人 -->
      <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="click"
      >
        <div class="avatar-wrapper">
          <img v-show="!!Location" :src="Location" class="user-avatar" />
          <div
            :title="!!userInfo ? userInfo.UserName : ''"
            :class="{ title: !!Location }"
          >
            {{ UserNickName }}
          </div>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu
          class="avatar-dropdown-menu"
          slot="dropdown"
          style="width: 150px"
        >
          <el-dropdown-item divided @click.native="logout">
            <span style="display: block">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getUserHeadPhoto } from "@/utils/auth";
// 登录弹窗
import LoginDialog from "../../components/Dialog/login.vue";
import Hamburger from "@/components/Hamburger";
import ErrorLog from "@/components/ErrorLog";
import LangToggle from "@/components/LangToggle";

export default {
  components: {
    Hamburger,
    ErrorLog,
    LangToggle,
    LoginDialog
  },

  computed: {
    ...mapGetters(["sidebar", "device", "userInfo", "UserHeadPhoto"]),
    Location() {
      if (this.UserHeadPhoto) {
        return this.UserHeadPhoto.photo;
      }
    },
    UserNickName() {
      return this.userInfo.UserNickName || "";
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    async logout() {
      await this.$store.dispatch("tagsView/delAllVisitedViews");
      await this.$store.dispatch("users/resetToken");
      this.$router.push(`/Home`);
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  text-align: center;
}
.navbar {
  height: 66px;
  overflow: hidden;
  position: relative;
  background: #5691f2;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  max-height: 100vh;

  .hamburger-container {
    line-height: 66px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 66px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 14px;
      color: #fff;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      width: 150px;
      height: 66px;
      margin-right: 30px;

      .avatar-wrapper {
        display: flex;
        position: relative;
        align-items: center;

        .user-avatar {
          cursor: pointer;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          margin-right: 5px;
        }

        div {
          cursor: pointer;
          color: #fff;
          font-size: 14px;
          margin: 0;
          margin-left: 5px;
          margin-right: 10px;
          vertical-align: 5px;
          height: 66px;
          overflow: hidden;
          /*自动隐藏文字*/
          text-overflow: ellipsis;
          white-space: nowrap;
          /*强制不换行*/
          width: 16em;
          /*不允许出现半汉字截断*/
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: 0px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Navbar.vue